import { getYearDateRange } from "../../../utils/date.js";
import "react-intl";
function getAvailableDateRange(isHistorical, selectedYear, historicalDateRange, recentDateRange) {
  let from = recentDateRange.from;
  let to = recentDateRange.to;
  if (isHistorical) {
    const yearDateRange = getYearDateRange(selectedYear);
    from = historicalDateRange.from < yearDateRange.from ? yearDateRange.from : historicalDateRange.from;
    to = historicalDateRange.to && historicalDateRange.to < yearDateRange.to ? historicalDateRange.to : yearDateRange.to;
  }
  return { from, to };
}
export {
  getAvailableDateRange
};
//# sourceMappingURL=utils.js.map
